import React from "react";
import PropTypes from "prop-types";
import "moment-timezone";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import pagamentosStyle from "assets/jss/material-dashboard-pro-react/views/pagamentosStyle.jsx";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../SweetAlertWrapper";
import Button from "../CustomButtons/Button";
import Refresh from "@material-ui/icons/Refresh";

function ListaPagamentos(props) {
  const {classes} = props;
  const pagamentos = props.pagamentos;

  const gerarNovaReferencia = async (pagamento) => {

    let titulo_caixa = pagamento.estado_pagamento === 'faltou' ? 'Gerar Nova Referência' : (pagamento.estado_pagamento === 'referencia_pendente' ? 'Gerar Referência' : null);
    let url = pagamento.estado_pagamento === 'faltou' ? "pagamentos/gerar_nova_referencia" : (pagamento.estado_pagamento === 'referencia_pendente' ? "pagamentos/gerar_referencia_pendente" : null);

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>{titulo_caixa}</span>
      </div>)}
      onConfirm={async () => {
        await connection.post(url, {
          pagamento: pagamento.id
        });
        window.App.hideModal();
        general.success("Foi criada uma nova referência multibanco", "Sucesso");
        window.location.reload(true);
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Gerar Referência"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <p style={{textAlign: "justify", margin: '9px'}}>Será gerada uma nova referência de pagamento com uma validade de 3 dias para finalização da inscrição {pagamento.tipo_acontecimento === 'curso' ? 'no curso' : 'na formação'} <i>{pagamento.designacao}</i>, após a qual será necessário a geração de uma referência nova.</p>
    </SweetAlert>);
  }

  let MetodoPagamento = ({metodo, pagamento}) => {
    switch (metodo) {
      case "mb":
        return <div>
          <div>
            {pagamento.estado_pagamento === 'pendente' && <strong style={{fontStyle: "italic"}}><span style={{color: "#999999"}}>Entidade:</span> {pagamento.dados_pagamento.entidade}</strong>}
          </div>
          <div>
            {pagamento.estado_pagamento === 'pendente' && <strong style={{fontStyle: "italic"}}><span style={{color: "#999999"}}>Ref:</span> {pagamento.dados_pagamento.ref}</strong>}
          </div>
          <div>
            {(pagamento.estado_pagamento === 'pendente' || pagamento.estado_pagamento === 'faltou' && new Date(pagamento.data_limite_pagamento) >= new Date()) && <strong style={{fontStyle: "italic"}}><span style={{color: "#999999"}}>Valor:</span> {pagamento.dados_pagamento?.valor}</strong>}
          </div>
          <div>
            {(pagamento.estado_pagamento === 'referencia_pendente' && !pagamento.dados_pagamento) && <strong style={{fontStyle: "italic"}}><span style={{color: "#999999"}}>Valor:</span> {pagamento.valor_a_pagar + ",00€"}</strong>}
          </div>
          <div>
            {(pagamento.estado_pagamento === 'faltou' && new Date(pagamento.data_limite_pagamento) >= new Date()) && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} style={{width: "170px", height: "25px"}} onClick={() => gerarNovaReferencia(pagamento)}>
              Nova Referência
            </Button>}
            {(pagamento.estado_pagamento === 'referencia_pendente' && !pagamento.dados_pagamento) && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} style={{width: "170px", height: "25px"}} onClick={() => gerarNovaReferencia(pagamento)}>
              Gerar Referência
            </Button>}
          </div>
        </div>;
      default:
        return null;
    }
  }

  return <table className={classes.tabelaPagamentos}>
    <tbody>
    {pagamentos.map(pagamento => <tr key={"pagamento_" + pagamento.id}>
      <td style={{maxWidth: 350}}>
        <strong>{pagamento.descricao}</strong>
      </td>
      <td>
        <MetodoPagamento metodo={pagamento.metodo} pagamento={pagamento}/>
      </td>
      <td style={{color: pagamento.estado.color}}>
        <span>{pagamento.estado.designacao}</span>
      </td>
      <td>
        {(pagamento.estado_pagamento === 'pendente' && new Date(pagamento.data_limite_pagamento) >= new Date()) && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} style={{height: '12px', width: '12px', padding: '15px'}} onClick={async () => {
          let estado_pagamento = await connection.post("pagamentos/verificar_estado_pagamento", {
            pagamento: pagamento.id
          })
          //window.location.reload(true);
          if (estado_pagamento.pago) {
            general.success("O estado do pagamento foi atualizado.", "Pagamento atualizado");
            props.atualizar && props.atualizar();
          } else {
            general.warning("O estado do pagamento continua pendente.", "Pagamento pendente");
          }
        }}>
          <Refresh style={{margin: 0}}/>
        </Button>}
      </td>
    </tr>)}
    </tbody>
  </table>
}

ListaPagamentos.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool
};

export default withStyles(pagamentosStyle)(ListaPagamentos);
